// @flow
import { useEffect } from "react";
import { isUndefined } from "lodash";

const clearTabSelectionOnNewBatch = (props: Object, prevProps: Object, clearAction: Function) => {
	const batchStartCounter = !isUndefined(props.batchStartCounter)
		? props.batchStartCounter
		: props.tabData.batchStartCounter;

	const prevBatchStartCounter = !isUndefined(prevProps.batchStartCounter)
		? prevProps.batchStartCounter
		: prevProps.tabData.batchStartCounter;

	if (props.contextData.selected
        && props.contextData.selected.length
        && batchStartCounter > prevBatchStartCounter) {
		clearAction();
	}
};

/**
 * call clearAction on unmounting of your component
 * @param clearAction - should be constant between your component's re-render !
 */
const useClearTabSelectionOnUnmount = (clearAction: () => void) => {
	useEffect(() =>
	// will only be called during unmount
		() => {
			clearAction();
		},
	[clearAction]);
};

export {
	clearTabSelectionOnNewBatch,
	useClearTabSelectionOnUnmount,
};
